// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAnHnB4eG8MxeXzPtGU0LL1Opa3Zin_Ncg",
  authDomain: "rinkclic.firebaseapp.com",
  projectId: "rinkclic",
  storageBucket: "rinkclic.appspot.com",
  messagingSenderId: "645538696266",
  appId: "1:645538696266:web:d8541c3589d432d1532ab3",
  measurementId: "G-XTGTJQECQ7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

let analytics = null;

if (typeof window !== "undefined") {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const isStage = window.location.hostname.includes("stage"); // Covers rinkclicstage

  if (!isLocal && !isStage) {
    analytics = getAnalytics(app);
  } else {
    console.log("Analytics disabled in development/staging");
  }
}

export { analytics, auth, db, googleProvider };

export default app;